import Head from "next/head";
import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import LoginContainer from "../../components/Authentication/LoginContainer";
import { LocalizedLoginMethodContainer } from "../../components/Authentication/LocalizedLoginMethodContainer";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useSuccessToast, useErrorToast } from "../../utils/showToast";

const LOGIN_TITLE = msg({ id: "Auth_login_title", message: "login" });

const EMAIL_CHANGE_SUCCESS_TOAST = msg({
  id: "Auth_email_change_success_toast",
  message: "Email change successful. Please sign in with your new email.",
});
const EMAIL_CHANGE_FAILED_TOAST = msg({
  id: "Auth_email_change_failed_toast",
  message: "Email change failed. Your email address was not changed.",
});
const LINK_EMAIL_SENT = msg({
  id: "Auth_link_email_sent",
  message:
    "An email has been sent to the owner of the order to complete the connection of phone number and orders.",
});

export default function Login() {
  const showSuccessToast = useSuccessToast();
  const showErrorToast = useErrorToast();
  const router = useRouter();
  const { _: i18n } = useLingui();

  useEffect(() => {
    if (!router.isReady) return;
    const { emailChangeSuccess } = router.query;
    if (emailChangeSuccess === "true") {
      showSuccessToast(i18n(EMAIL_CHANGE_SUCCESS_TOAST));
      router.replace("/auth/login");
    } else if (emailChangeSuccess === "false") {
      showErrorToast(i18n(EMAIL_CHANGE_FAILED_TOAST));
      router.replace("/auth/login");
    }
  }, [
    router,
    router.isReady,
    router.query,
    showErrorToast,
    showSuccessToast,
    i18n,
  ]);

  return (
    <>
      <Head>
        <title>Wooting | Login</title>
      </Head>
      <LoginContainer type={i18n(LOGIN_TITLE)}>
        <LocalizedLoginMethodContainer />
      </LoginContainer>
    </>
  );
}
